/* Seletor de idioma retro — 5 botões: [PT][ES][IT][FR][EN] */
import React, { useState } from 'react';
import type { Locale } from '../types';

interface LangSwitchProps {
  locale: Locale;
  onLocaleChange: (locale: Locale) => void;
}

const LOCALES: { code: Locale; label: string }[] = [
  { code: 'pt-BR', label: 'PT' },
  { code: 'es', label: 'ES' },
  { code: 'it', label: 'IT' },
  { code: 'fr', label: 'FR' },
  { code: 'en', label: 'EN' },
];

export function LangSwitch({ locale, onLocaleChange }: LangSwitchProps) {
  const [expanded, setExpanded] = useState(false);

  // Mobile: mostra dropdown com idioma ativo + lista colapsável
  // Desktop: mostra todos os botões lado a lado
  return (
    <>
      {/* Desktop: todos os botões visíveis */}
      <nav
        aria-label="Seletor de idioma"
        style={{
          display: 'flex',
          gap: '4px',
          alignItems: 'center',
        }}
      >
        {LOCALES.map(({ code, label }) => {
          const isActive = locale === code;
          return (
            <button
              key={code}
              type="button"
              onClick={() => onLocaleChange(code)}
              aria-pressed={isActive}
              aria-label={`Idioma: ${label}`}
              style={{
                fontFamily: 'var(--font-sans)',
                fontSize: '12px',
                fontWeight: 600,
                padding: '6px 10px',
                background: isActive ? 'rgba(124,124,248,0.14)' : 'transparent',
                border: `1px solid ${isActive ? 'var(--violet)' : 'rgba(199,200,206,0.30)'}`,
                color: isActive ? '#FFFFFF' : 'rgba(199,200,206,0.85)',
                cursor: 'pointer',
                boxShadow: 'none',
                letterSpacing: '0.02em',
                transition: 'all 180ms ease-out',
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = '#FFFFFF';
                  e.currentTarget.style.borderColor = 'var(--violet)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = 'rgba(199,200,206,0.85)';
                  e.currentTarget.style.borderColor = 'rgba(199,200,206,0.30)';
                }
              }}
            >
              {label}
            </button>
          );
        })}
      </nav>

      {/* Mobile: dropdown colapsável — aparece só em tela pequena via CSS class */}
      {/* Implementação via CSS media query no global.css do app host */}
    </>
  );
}
